export const buildShortLink = (domain: string, shortLinkId: string): string =>
    `${domain.replace(/\/$/, '')}/${shortLinkId}`;
